import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal";
import BootstrapTable from "react-bootstrap-table-next";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import filterFactory, {
  textFilter,
  selectFilter,
  // dateFilter,
} from "react-bootstrap-table2-filter";
require("react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css");
import ToolkitProvider, { CSVExport } from "react-bootstrap-table2-toolkit"; // , { Search, CSVExport,}
import LoadingAlert from "../../components/LoadingAlert";
// import { CSVLink } from "react-csv";

// Import Service
import authService from "../../services/auth.service";
import assocService from "../../services/assoc.service";

//Import Modal
// import Modalapprove from "./Modalapprove";

//Import Loading
// import Spinner from "react-bootstrap/Spinner";

// import { confirmAlert } from "react-confirm-alert";
// import "react-confirm-alert/src/react-confirm-alert.css";

import "../Association/association.css";

const ModalViewAssoc = (props) => {
  const [loading, setLoading] = useState(false);
  // const [loadingAlert, setLoadingAlert] = useState(false);
  const [assocNameThai, setAssocNameThai] = useState("");
  // const [error, setError] = useState(false);
  // const [data, setData] = useState([]);

  const user = authService.getCurrentUser();

  // const { SearchBar } = Search;

  const { ExportCSVButton } = CSVExport;

  const handleClose = () => {
    props.hidden(false);
    // props.data([]);
  };

  // useEffect(() => {
  //   setView(props);
  //   // setLoading(false);
  //   // getData(user.user.user_assoc);
  //   getAssocName(user.user.user_assoc);
  // }, [props, user.user.user_assoc]);

  useEffect(() => {
    setView(props);
    // setData();
    // setLoading(false);
    // getData(user.user.user_assoc);
    getAssocName(user.user.user_assoc);
  }, [user.user.user_assoc]);

  const getAssocName = () => {
    console.log("gesdf");
    console.log(props.data);
    if (user.user.user_assoc) {
      const assoc_id = user.user.user_assoc;
      assocService
        .getMembersByAssoc({ assoc_id: assoc_id })
        .then((response) => {
          setAssocNameThai(response.data.data.association_name_th);
        });
      // console.log(assoc);
    }
  };
  const setView = (props) => {
    // console.log(props.data);
    if (props) {
      setLoading(true);
      // setData(props.data);
      setLoading(false);
    }
  };

  const headerSortingStyle = {
    backgroundColor: "#D4EFDF",
    verticalAlign: "center",
  };

  // const filterStatus = {
  //   ส่งปกติ: "ส่งปกติ",
  //   ขาดส่ง: "ขาดส่ง",
  //   ไม่มีการส่ง: "ไม่มีการส่ง",
  // };

  // const filterRegstate = {
  //   ชาวไร่: "ชาวไร่",
  //   พ้นสภาพ: "พ้นสภาพ",
  //   "-": "ไม่มีข้อมูล",
  // };

  // const filterDopaValidate = {
  //   มีชีวิต: "มีชีวิต",
  //   เสียชีวิต: "เสียชีวิต",
  // };

  const filterMaster = {
    "หน.กลุ่ม": "หน.กลุ่ม",
    สมาชิก: "สมาชิก",
  };

  // const dopaValidateFormatter = (cell) => {
  //   if (cell == "มีชีวิต") {
  //     return <p className="text-success">{cell}</p>;
  //   } else if (cell == "เสียชีวิต") {
  //     return <p className="text-danger">{cell}</p>;
  //   }
  // };

  const statusFormatter = (cell) => {
    // console.log(cell);
    if (
      cell == "เป็นสมาชิก" ||
      cell == "ชาวไร่" ||
      cell == "มีชีวิต" ||
      cell == "ส่งปกติ"
    ) {
      return <p className="text-success">{cell}</p>;
    } else if (cell == "ลาออก" || cell == "ขาดส่ง") {
      return <p className="text-warning">{cell}</p>;
    } else if (cell == "รออนุมัติ") {
      return <p className="text-secondary">{cell}</p>;
    } else if (
      cell == "พ้นสภาพ" ||
      cell == "เสียชีวิต" ||
      cell == "ไม่มีการส่ง"
    ) {
      return <p className="text-danger">{cell}</p>;
    } else {
      return <p>{cell}</p>;
    }
  };

  const dateFormatter = (cell) => {
    const getdate = new Date(cell);
    return (
      <p>
        {getdate.toLocaleString("th-TH", {
          year: "2-digit",
          month: "short",
          day: "numeric",
        })}
      </p>
    );
  };

  const columns = [
    {
      text: "สถาบัน",
      filter: textFilter({
        placeholder: "ชื่อ-สกุล",
        style: { fontSize: "98%", width: "100%" },
      }),
      dataField: "assocname",
      sort: true,
      headerSortingStyle,
      editable: false,
      headerStyle: () => {
        return { width: "20%" };
      },
      style: { textAlign: "left" },
    },
    {
      text: "เริ่มเป็นสมาชิก",
      dataField: "createdat",
      formatter: dateFormatter,
      sort: true,
      headerSortingStyle,
      editable: false,
      headerStyle: () => {
        return { width: "10%" };
      },
      // filter: dateFilter(),
    },
    {
      text: "สถานะภาพ",
      dataField: "status_text",
      // formatter: dateFormatter,
      sort: true,
      headerSortingStyle,
      editable: false,
      headerStyle: () => {
        return { width: "10%" };
      },
      // filter: dateFilter(),
    },
    {
      text: "หน.กลุ่ม",
      dataField: "membertype",
      formatter: statusFormatter,
      filter: selectFilter({
        placeholder: "เลือก",
        style: { fontSize: "98%", width: "100%" },
        options: filterMaster,
      }),
      editable: false,
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    // {
    //   text: "ส่งผลผลิต",
    //   dataField: "memberstatus",
    //   formatter: statusFormatter,
    //   filter: selectFilter({
    //     placeholder: "เลือก",
    //     style: { fontSize: "98%", width: "100%" },
    //     options: filterStatus,
    //   }),
    //   headerStyle: () => {
    //     return { width: "10%" };
    //   },
    // },
    // {
    //   dataField: "regstatus",
    //   text: "การเป็นชาวไร่",
    //   formatter: statusFormatter,
    //   filter: selectFilter({
    //     placeholder: "เลือก",
    //     style: { fontSize: "98%", width: "100%" },
    //     options: filterRegstate,
    //   }),
    //   editable: false,
    //   headerStyle: () => {
    //     return { width: "10%" };
    //   },
    // },
  ];

  // const headers = [
  //   ...columns.map((a) => {
  //     return { label: a.text, key: a.dataField, csvExport: a.csvExport };
  //   }),
  // ];

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 5,
    firstPageText: "|<",
    lastPageText: ">|",
    nextPageText: ">>",
    prePageText: "<<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
    onSizePerPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
  });

  // if (loading)
  //   return (
  //     <>
  //       <br />
  //       <p>
  //         <Spinner animation="border" variant="success" />
  //         <span>&nbsp;กรุณารอ เนื่องจากข้อมูลมีปริมาณมาก</span>
  //       </p>
  //     </>
  //   );
  // if (error) return `Error :${error}`;

  return (
    <div>
      {loading ? <LoadingAlert /> : ""}
      {/* {JSON.stringify(data)} */}
      <h3 className="text-center">{assocNameThai}</h3>
      <ToolkitProvider
        bootstrap4
        keyField="memberId"
        data={props.data}
        columns={columns}
        search
        exportCSV={{
          fileName: props.data.assocname + ".csv",
          separator: ",",
          ignoreHeader: false,
          noAutoBOM: true,
          blobType: "text/csv;charset=utf-8",
          onlyExportFiltered: true,
          exportAll: false,
        }}
      >
        {(prop) => (
          <Modal
            size="lg"
            show={props.show}
            onHide={handleClose}
            animation={false}
          >
            <Modal.Header closeButton>
              <Modal.Title></Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <React.Fragment>
                <div>
                  <h3 className="text-center">ข้อมูลการเป็นสมาชิกสถาบัน</h3>
                  <div className="text-left">
                    <ExportCSVButton
                      {...prop.csvProps}
                      style={{
                        padding: ".375rem .75rem",
                        fontSize: "1rem",
                        float: "right",
                      }}
                    >
                      <i className="bi bi-download"></i>
                    </ExportCSVButton>
                  </div>
                </div>
                <BootstrapTable
                  pagination={pagination}
                  filter={filterFactory()}
                  {...prop.baseProps}
                />
              </React.Fragment>
            </Modal.Body>
            <Modal.Footer>
              {/* <button className="btn btn-warning" onClick={handleClose}>
                Close
              </button> */}
            </Modal.Footer>
          </Modal>
        )}
      </ToolkitProvider>
    </div>
  );
};

export default ModalViewAssoc;

ModalViewAssoc.propTypes = {
  show: PropTypes.bool,
  hidden: PropTypes.func,
  data: PropTypes.array,
  setdata: PropTypes.func,
  // association: PropTypes.array,
  // association_id: PropTypes.number,
  // association_name: PropTypes.string,
};
